import axios from 'axios';
import { ClDonneesPrevSimulation, PrevSimulRequest } from '../Model/PrevSimulData';
import { Dayjs } from 'dayjs';


export const GetPrevSimulData = async (serviceUrl : string, username : string, 
                                        dateBegin : Dayjs, dateEnd : Dayjs) => {
    var prevSimulDataIn = new PrevSimulRequest();
    prevSimulDataIn.username = username;
    prevSimulDataIn.datebegin = dateBegin;
    prevSimulDataIn.dateEnd = dateEnd;
    try{
        var url = serviceUrl + 'Presta/GetListPrevSimul';

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true,
            timeout: 0
        };

        const {data} =  await axios.post<ClDonneesPrevSimulation[]>(url, prevSimulDataIn, requestOptions);
        return data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            if(error.response?.status == 401)
            {
              return "PRESTA_ERROR_UNAUTHORIZED";
            }
            else
            {
              return error.message;
            }
        }
        else {
            return 'Loading simulations Error';
        }
    }
}